import React from 'react';

import { Link } from 'react-router-dom';

import { bemClassName } from '@src/utils/bem';

import { StyledSocialButton } from './styles';

const b = bemClassName('social-button');

const SocialButton = ({ children, link, ariaLabel }) => {
  return (
    <StyledSocialButton>
      <Link className={b()} to={link} aria-label={ariaLabel}>
        {children}
      </Link>
    </StyledSocialButton>
  );
};

export default SocialButton;
